// Shared keyboard-event guards. Extracted from useGlobalHotkeys so page-scoped
// shortcut hooks (e.g. useTasksKeyboardShortcuts) use the exact same rules.

export function isEditable(element: HTMLElement | null): boolean {
  if (!element) return false;
  const tagName = element.tagName?.toLowerCase();
  return tagName === "input" || tagName === "textarea" || element.isContentEditable;
}

/**
 * True when the user is focused on an editable surface. Checks both the event
 * target AND document.activeElement: the two can diverge (e.g. a keydown that
 * bubbles up from a portal, or a synthetic event), and we want to suppress
 * single-key shortcuts whenever focus is in a field either way.
 */
export function isTypingTarget(target: EventTarget | null): boolean {
  if (isEditable(target as HTMLElement | null)) return true;
  if (typeof document !== "undefined" && isEditable(document.activeElement as HTMLElement | null)) {
    return true;
  }
  return false;
}

/**
 * True when a modal dialog (Radix Dialog / AlertDialog, both rendered with
 * data-state="open") is mounted. We don't want a bare "/" or the g-sequence to
 * fire behind / underneath an open modal.
 */
export function isModalOpen(): boolean {
  if (typeof document === "undefined") return false;
  return document.querySelector(
    '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]'
  ) !== null;
}
